/**
 * Self-service contact-card API (ADR-141 §5).
 *
 * Typed openapi-fetch calls over `/api/v2/me/contact*` — the SMS mirror of
 * AIM's `main/services/contacts` module. The lib client's
 * auth/refresh/GPC/vendor-org middleware applies via `client`.
 */
import { client } from '../lib/http-client';

function unwrap<T>(result: { data?: T; error?: unknown }): T {
  if (result.error !== undefined) {
    throw result.error;
  }
  return result.data as T;
}

export const getMyContact = async () => {
  const result = await client.GET('/api/v2/me/contact/');
  return unwrap(result);
};

export const addMyContactDestination = async (
  channelCode: string,
  address: string,
) => {
  const result = await client.POST('/api/v2/me/contact/destinations/', {
    body: { channel_code: channelCode, address } as never,
  });
  return unwrap(result);
};

export const updateMyContactDestination = async (
  id: number,
  patch: { enabled?: boolean; priority?: number; address?: string },
) => {
  const result = await client.PATCH(
    '/api/v2/me/contact/destinations/{destination_id}/',
    {
      params: { path: { destination_id: id } },
      body: patch as never,
    },
  );
  return unwrap(result);
};

export const removeMyContactDestination = async (id: number) => {
  const result = await client.DELETE(
    '/api/v2/me/contact/destinations/{destination_id}/',
    {
      params: { path: { destination_id: id } },
    },
  );
  return unwrap(result);
};

export const sendDestinationVerification = async (id: number) => {
  const result = await client.POST(
    '/api/v2/me/contact/destinations/{destination_id}/send-verification/',
    {
      params: { path: { destination_id: id } },
    },
  );
  return unwrap(result);
};
